import React, { FC } from 'react';

import routeToExplore from 'src/prize/services/routeToExplore';
import { SvgUse } from 'src/shoppe/elements/SvgUse';

import styles from './index.module.sass';

export const Logo: FC = () => (
  <a className={`${styles.link} powered-by`} href={routeToExplore( '/' )}>
    <div className={`${styles.logo} logo`}>
      <SvgUse
        ariaLabel="We Ship on Goldbelly"
        height={55}
        name="we-ship-on-goldbelly"
        width={128}
      />
    </div>
  </a>
);
